import en from "./languages/en.json";
import hi from "./languages/hi.json";

const languages = { en, hi };
let currentLang = window.localStorage.getItem("lang") || "en";

export const getString = (key) => {
  return languages[currentLang][key] || key;
};

export const setLanguage = (lang) => {
  currentLang = lang;

  window.localStorage.setItem("lang", lang);

  window.location.reload();
};